const getRandomInt = max => Math.floor(Math.random() * Math.floor(max));

const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n);

export { isNumeric, getRandomInt };
